import { render, staticRenderFns } from "./FuncionarioCambiarPassword.vue?vue&type=template&id=2049c2eb&"
import script from "./FuncionarioCambiarPassword.vue?vue&type=script&lang=js&"
export * from "./FuncionarioCambiarPassword.vue?vue&type=script&lang=js&"
import style0 from "./FuncionarioCambiarPassword.vue?vue&type=style&index=0&id=2049c2eb&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports